import { render, staticRenderFns } from "./FilterCampaigns.vue?vue&type=template&id=5cba5e96&scoped=true&"
import script from "./FilterCampaigns.vue?vue&type=script&lang=js&"
export * from "./FilterCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./FilterCampaigns.vue?vue&type=style&index=0&id=5cba5e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba5e96",
  null
  
)

export default component.exports